import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false); // 禁止凍結
export const travelDetailSlice = createSlice({
  name: 'travelDetail',
  initialState: {
    reqData: {
      travel_no: '',
      m_class: '',
      m_mid: '',
    },
    resData: [],
  },
  reducers: {
    travelDetailUpdate: (state, action) => {
      sessionStorage.setItem('custom-itinerary-travelDetail', JSON.stringify(action.payload));
      return action.payload;
    },
    travelDetailReset: () => {
      sessionStorage.removeItem('custom-itinerary-travelDetail');
      return {
        reqData: {
          travel_no: '',
          m_class: '',
          m_mid: '',
        },
        resData: [],
      };
    }
  },
});

/** 查詢行程 new_1版本 */
export const travelDetailSelect = (state) => state.travelDetail;
export const { travelDetailUpdate, travelDetailReset } = travelDetailSlice.actions;
export default travelDetailSlice.reducer;
